import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const CreateReplyTemplateValidationSchema = z.object({
  title: z.string().min(1, 'Template name is required'),
  content: z.string(),
});
export type TCreateReplyTemplateValidation = z.infer<typeof CreateReplyTemplateValidationSchema>;
export type TCreateReplyTemplatePayload = TCreateReplyTemplateValidation;
export type TCreateReplyTemplateResponse = ApiResponse<unknown>;

export const createReplyTemplate = (payload: TCreateReplyTemplatePayload): Promise<TCreateReplyTemplateResponse> => {
  const url = '/template';

  return axiosInstance.post(url, payload);
};

type TUseCreateReplyTemplateMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof createReplyTemplate, AxiosErrorCustom>;
};

export const useCreateReplyTemplateMutation = ({ mutationConfigOptions }: TUseCreateReplyTemplateMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};
  return useMutation({
    mutationFn: createReplyTemplate,
    ...restConfigOptions,
  });
};
